if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      
      this.inputElement = this.querySelector('[name="quantity"]');
      this.attachListeners();
    }

    attachListeners() {
      this.querySelector('[data-action="decrease-picker-quantity"]').addEventListener('click', this.onDecrease.bind(this));
      this.querySelector('[data-action="increase-picker-quantity"]').addEventListener('click', this.onIncrease.bind(this));
      // this.delegateElement.on('click', '[data-action="decrease-picker-quantity"]', this._onDecrease.bind(this));
      // this.delegateElement.on('click', '[data-action="increase-picker-quantity"]', this._onIncrease.bind(this));
      this.addEventListener('keyup', this.onInputValueChanged.bind(this));
      this.addEventListener('focusout', this.onInputFocusOut.bind(this));
      // this.delegateElement.on('keyup', this._onInputValueChanged.bind(this));
      // this.delegateElement.on('focusout', this._onInputFocusOut.bind(this));
    }
    
    onDecrease() {
      var minQty = this.classList.contains('quantity-selector--product-table') ? 0 : 1;
      this.inputElement.value = Math.max(minQty, parseInt(this.inputElement.value) - 1);
      this.inputElement.dispatchEvent(new CustomEvent('change'));
      // this.inputElement.value = Math.max(1, parseInt(this.inputElement.value) - 1);
    }
    
    onIncrease() {
      this.inputElement.value = parseInt(this.inputElement.value) + 1;

      if (!this.inputElement.hasAttribute('max')) return this.inputElement.dispatchEvent(new CustomEvent('change'));
      if (parseInt(this.inputElement.value) > parseInt(this.inputElement.max)) this.inputElement.value = parseInt(this.inputElement.max);
      this.inputElement.dispatchEvent(new CustomEvent('change'));
    }
    
    onInputValueChanged(event) {
      var value = event.target.value;
      var minQty = this.classList.contains('quantity-selector--product-table') ? 0 : 1;

      if (value !== '' && isNaN(value)) {
        event.target.value = Math.max(minQty, parseInt(value) || minQty);
        if (!event.target.hasAttribute('max')) return;
        if (parseInt(event.target.value) > parseInt(event.target.max)) event.target.value = parseInt(event.target.max);
      }
    }
    
    onInputFocusOut(event) {
      var minQty = this.classList.contains('quantity-selector--product-table') ? 0 : 1;
      event.target.value = Math.max(minQty, parseInt(event.target.value) || minQty);
      if (!event.target.hasAttribute('max')) return;
      if (parseInt(event.target.value) > parseInt(event.target.max)) event.target.value = parseInt(event.target.max);
    }

  }
  customElements.define('quantity-input', QuantityInput);
}